
export const header_default_styles = theme => ({
    header: {
        zIndex: 9,
        position: 'fixed',
        top: 15,
        left: 25
    },
    header_wrapper: {
        position: 'relative'
    },
    title_wrapper: {
        display: 'flex',
        flexDirection: 'column',
    },
    main_title: {
        paddingBottom: 10,
        display: 'flex', 
        alignItems: 'center'
    },
    variant_switch_section: {
        borderTopRightRadius: 3,
        borderTopLeftRadius: 3,
        borderBottomRightRadius: 3,
        borderBottomLeftRadius: 3,
        maxWidth: 355,
        width: '100%',
        '@media(max-width: 600px)' : {
            maxWidth: 300,
        },
    },
    variant_switch_open: {
        background: 'linear-gradient(130deg, rgba(98,98,98,.80) 0%, rgba(35,31,32,0) 100%);',
    },
    main_variant_wrapper: {
        display: 'flex',
        position: 'relative',
        cursor: 'pointer'
    },
    sub_variant_wrapper: {
        borderTop: 'solid 1px #686868',
        paddingTop: 5,
        maxHeight: 475,
        overflow: 'scroll',
    },
    clickable_row: {
        display: 'flex',
        cursor: 'pointer',
    },
    clickable_row_disabled: {
        pointerEvents: 'none',
        '& $sub_title_variant': {
            '& span': {
                fontWeight: 'bold',
            }
        }
    },
    triangle_up: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 48,
        height: 48,
        '& span': {
            width: 0,
            height: 0,
            borderLeft: '6px solid transparent',
            borderRight: '6px solid transparent',
            borderBottom: '5px solid #bfbfbf',
        }
    },
    triangle_down: {
        position: 'absolute',
        top: '50%',
        left: -12,
        height: 48,
        '& span': {
            width: 0,
            height: 0,
            borderLeft: '6px solid transparent',
            borderRight: '6px solid transparent',
            borderTop: '5px solid #bfbfbf',
        }
    },
    title_swatch: {
        height: 48,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative'
    },
    color_swatch: {
        width: '100%', 
        height: '100%'
    },
    image_swatch: {
        width: 48,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        "& img": {
            width: '100%',
            maxWidth: 30,
            border: 'solid 1px #666',
            borderRadius: '50%'
        }
    },
    main_title_variant: {
        display: 'flex',
        alignItems: 'center',
        transition: 'all .3s ease',
        opacity: 1,
        '& span': {
            fontWeight: 500,
            fontSize: 16,
            color: '#bfbfbf',
            lineHeight: 1,
            display: 'block',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
            maxWidth: '265px',
            overflow: 'hidden',
            '@media(max-width: 600px)' : {
                fontSize: 15,
            },
        },
        '&:hover': {
            opacity: .9
        }
    },
    sub_title_variant: {
        display: 'flex',
        alignItems: 'center',
        transition: 'all .3s ease',
        opacity: 1,
        '& span': {
            fontWeight: 300,
            fontSize: 14,
            color: '#bfbfbf',
            lineHeight: 1,
            display: 'block',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
            maxWidth: '265px',
            overflow: 'hidden',
            '@media(max-width: 600px)' : {
                fontSize: 12,
            },
        },
        '&:hover': {
            opacity: .65
        }
    },
    work_section: {
        display: 'flex',
        borderRadius: 3,
    },
    variantTitle: {
        margin: 0,
        fontSize: '18px',
        fontWeight: 700,
        lineHeight: '25px',
        color: '#bfbfbf',
        '@media (max-width: 470px)': {
            display: 'block',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
            maxWidth: '300px',
            overflow: 'hidden'
        },
    },
    optionsBlock: {
        display: 'flex',
        '& h3:first-child': {
            paddingLeft: 0
        }
    },
    optionsText: {
        margin: 0,
        fontSize: '12px',
        fontWeight: 600,
        color: '#ababab',
        paddingLeft: 5,
        '@media (max-width: 470px)': {
            display: 'block',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
            maxWidth: '300px',
            overflow: 'hidden'
        },
    }
});